<template>
  <BaseAction>
    <div class="d-flex justify-center">
      <SecondaryButton @click.native="openDialog" textColor="#d10a3a">
        <v-img
          src="@/assets/svg/withdraw_offer.svg"
          class="offer-action-icon"
          size="50"
        />
        <span :class="{ 'ml-1': isMobile }"> Withdraw Offer </span>
      </SecondaryButton>
      <WithdrawOfferDialog v-if="isOpen" @close="closeDialog" />
    </div>
  </BaseAction>
</template>

<script>
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import WithdrawOfferDialog from "@/views/offers/dialogs/WithdrawOfferDialog";
import BaseAction from "@/components/common/BaseAction";

export default {
  name: "WithdrawOfferAction",
  components: {
    SecondaryButton,
    WithdrawOfferDialog,
    BaseAction
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    }
  }
};
</script>
<style lang="scss"></style>
